import { Component } from '@angular/core';

import { PlantMapAdminService } from '../services/plant-map-admin.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';
import { PopupService } from '../../shared/services/pop-up.service';

import { STATIC_VALUE } from '../../shared/configuration/static.value';

import { LazyLoadEvent } from 'primeng/components/common/api';
import { FilterMetadata } from 'primeng/components/common/api';
import { StorageService } from '../../shared/services/storage.service';

@Component({
    selector: 'plantmap-admin-all',
    templateUrl: 'all.component.html'
})
export class PlantmapAdminAllComponent {

    totalRecords: number;
    currentStart: number;
    currentEnd: number;

    vPageSize: number = STATIC_VALUE.TABLE.PAGE_SIZE;

    vLoading: boolean = false;
    vShowTable: boolean = false;

    // vPlantRequestID: string = "";
    vPlantStatus: string = "";

    resettedPlantTable: number = 0;

    vPlantSearchBy: string = '';
    vPlantFilterBy: string = '';
    vPlantFromDate: Date;
    vPlantToDate: Date;
    vPlantFromDateFilterBy: string = '';
    vPlantToDateFilterBy: string = '';
    //vPlantDate: Date;

    //Kowsalya
    sortOrder: number;

    vPlantmapLists: Array<{
        plant_record_id: number,
        plant_request_id: string,
        create_date: string,
        updated_date: string,
        project_title: string,
        location: string,
        restricted_area: number,
        status: string
    }>;

    constructor(
        private _plantMapAdminService: PlantMapAdminService,
        private _pageNavigationService: PageNavigationService,
        private _layoutService: LayoutService,
        private _popupService: PopupService,
        private _storageService: StorageService
    ) { }

    ngOnInit() {
        this._layoutService.setCurrentPage('plantmap-admin-all');
        this.vLoading = true;
        this._plantMapAdminService.loadTotalData(this.vPlantSearchBy, this.vPlantFilterBy.trim(), this.vPlantStatus).then(
            (resolve) => {
                this._plantMapAdminService.loadPlantMaps(0, this.vPageSize, this.vPlantSearchBy, this.vPlantFilterBy.trim(), this.vPlantStatus, 0).then(
                    (resolve) => {
                        this.vLoading = false;
                        this.totalRecords = this._plantMapAdminService.getTotalData();
                        this.currentStart = 1;
                        this.currentEnd = 1 * 10;
                        this.vPlantmapLists = this._plantMapAdminService.getPlantmapsList();
                    },
                    (reject) => {
                        this.vLoading = false;
                    }
                );
            },
            (reject) => {
                this.vLoading = false;
            }
        );
        this._plantMapAdminService.loadAllPlantStatus();
        this.vPlantSearchBy = this.getSearchBy()[0].type;
    }

    getPlantStatusList() {
        return this._plantMapAdminService.getAllPlantStatus();
    }

    getSearchBy() {
        let data = [];
        for (let pm of STATIC_VALUE.SEARCH_BY.admin) {
            if (pm.plantValue !== '') {
                data.push(pm);
            }
        }
        return data;
    }

    resetPlantFilter() {
        this.vPlantFilterBy = '';
        //this.vPlantDate = null;
        this.vPlantFromDate = null;
        this.vPlantToDate = null;
    }

    /*filterDatePlant() {
        this.vPlantFilterBy = this.vPlantDate.getFullYear() + '' + ("0" + (this.vPlantDate.getMonth() + 1)).slice(-2) + '' + ("0" + this.vPlantDate.getDate()).slice(-2);
        this.filterPlant();
    }*/

    filterFromDatePlant() {
        this.vPlantFromDateFilterBy = this.vPlantFromDate.getFullYear() + '' + ("0" + (this.vPlantFromDate.getMonth() + 1)).slice(-2) + '' + ("0" + this.vPlantFromDate.getDate()).slice(-2);
        //this.filterPlant();
    }

    filterToDatePlant() {
        this.vPlantToDateFilterBy = this.vPlantToDate.getFullYear() + '' + ("0" + (this.vPlantToDate.getMonth() + 1)).slice(-2) + '' + ("0" + this.vPlantToDate.getDate()).slice(-2);
        this.filterPlantDate();
    }

    clearInputPlant() {
        this.resetPlantFilter();
        this.vPlantSearchBy = this.getSearchBy()[0].type;//Kowsalya
        this.filterPlant();
    }

    filterPlant() {
        this.vLoading = true;
        this.resettedPlantTable = 0;
        this._plantMapAdminService.loadTotalData(this.vPlantSearchBy, this.vPlantFilterBy.trim(), this.vPlantStatus).then(
            (resolve) => {
                //this.totalRecords = this._plantMapAdminService.getTotalData();
                this._plantMapAdminService.loadPlantMaps(0, this.vPageSize, this.vPlantSearchBy, this.vPlantFilterBy.trim(), this.vPlantStatus, 0).then(
                    (resolve) => {
                        this.vLoading = false;
                        this.totalRecords = this._plantMapAdminService.getTotalData();
                        this.currentStart = 1;
                        this.currentEnd = 1 * 10;
                        this.vPlantmapLists = this._plantMapAdminService.getPlantmapsList();
                    },
                    (reject) => {
                        this.vLoading = false;
                    }
                );
            },
            (reject) => {
                this.vLoading = false;
            }
        );
    }

    //Kowsalya
    filterPlantDate() {
        this.vLoading = true;
        this.resettedPlantTable = 0;
        this._plantMapAdminService.loadTotalDatadate(this.vPlantSearchBy, this.vPlantFromDateFilterBy, this.vPlantToDateFilterBy, this.vPlantStatus).then(
            (resolve) => {

                this._plantMapAdminService.loadAvailablePlantMaps(0, this.vPageSize, this.vPlantSearchBy, this.vPlantFromDateFilterBy, this.vPlantToDateFilterBy, this.vPlantStatus, 0).then(
                    (resolve) => {
                        this.vLoading = false;
                        this.totalRecords = this._plantMapAdminService.getTotalData();
                        this.currentStart = 1;
                        this.currentEnd = 1 * 10;
                        this.vPlantmapLists = this._plantMapAdminService.getPlantmapsList();
                    },
                    (reject) => {
                        this.vLoading = false;
                    }
                );
            },
            (reject) => {
                this.vLoading = false;
            }
        );
    }

    refreshPlant() {
        if (this.vPlantSearchBy != 'applicationDate') {
            this.filterPlant();
            console.log("Line 182");
        }
        else {
            if (this.vPlantFromDate != null && this.vPlantToDate) {
                this.filterPlantDate();
                console.log("Line 188");
            }
            else {
                if (this.vPlantFromDate == null) {
                    this._popupService.openGeneralConfirmationPopup('Error', 'Please select the From Date', '', false, false);
                }
                else {
                    this._popupService.openGeneralConfirmationPopup('Error', 'Please select the To Date', '', false, false);
                }
            }
        }
    }
    //Kowsalya


    //Kowsalya

    loadPlantLazy(event: LazyLoadEvent) {
        //in a real application, make a remote request to load data using state metadata from event
        //event.first = First row offset
        //event.rows = Number of rows per page
        //event.sortField = Field name to sort with
        //event.sortOrder = Sort order as number, 1 for asc and -1 for dec
        //filters: FilterMetadata object having field as key and filter value, filter matchMode as value

        if (this.vLoading) {
            return;
        }
        let vPageNumber = event.first / this.vPageSize;
        this.vLoading = true;
        if (this.vPlantSearchBy != 'applicationDate') {
            this._plantMapAdminService.loadPlantMaps(vPageNumber, this.vPageSize, this.vPlantSearchBy, this.vPlantFilterBy.trim(), this.vPlantStatus, event.sortOrder).then(
                (resolve) => {
                    this.vLoading = false;
                    this.vPlantmapLists = this._plantMapAdminService.getPlantmapsList();
                    /*if (this.sortOrder == 1){
                        this.vPlantmapLists = this._plantMapAdminService.getPlantmapsList().sort((a, b) => (a.plant_record_id < b.plant_record_id) ? -1 : 1);
                    }
                    else{
                        this.vPlantmapLists = this._plantMapAdminService.getPlantmapsList().sort((a, b) => (a.plant_record_id > b.plant_record_id) ? -1 : 1);
                    }*/
                    this.currentStart = ((vPageNumber + 1) * 10) - 9;
                    this.currentEnd = (vPageNumber + 1) * 10 > this.totalRecords ? this.totalRecords : (vPageNumber + 1) * 10;
                },
                (reject) => {
                    this.vLoading = false;
                }
            );
        }
        else {
            this._plantMapAdminService.loadAvailablePlantMaps(vPageNumber, this.vPageSize, this.vPlantSearchBy, this.vPlantFromDateFilterBy, this.vPlantToDateFilterBy, this.vPlantStatus, event.sortOrder).then(
                (resolve) => {
                    this.vLoading = false;
                    this.vPlantmapLists = this._plantMapAdminService.getPlantmapsList();
                    /*if (this.sortOrder == 1){
                        this.vPlantmapLists = this._plantMapAdminService.getPlantmapsList().sort((a, b) => (a.plant_record_id < b.plant_record_id) ? -1 : 1);
                    }
                    else{
                        this.vPlantmapLists = this._plantMapAdminService.getPlantmapsList().sort((a, b) => (a.plant_record_id > b.plant_record_id) ? -1 : 1);
                    }*/
                    this.currentStart = ((vPageNumber + 1) * 10) - 9;
                    this.currentEnd = (vPageNumber + 1) * 10 > this.totalRecords ? this.totalRecords : (vPageNumber + 1) * 10;
                },
                (reject) => {
                    this.vLoading = false;
                }
            );
        }

    }
    //Kowsalya

    getDetailPlantmap() {
        return this._plantMapAdminService.getPlantMapDetailData();
    }

    viewPlantmap(pPlantID) {
        this._plantMapAdminService.loadDetailPlantMap(pPlantID).then(
            (resolve) => {
                if (this._plantMapAdminService.vPlantMapDetail.trans_method === STATIC_VALUE.PAYMENT_METHOD.creditCard.key) {
                    this._plantMapAdminService.vPlantMapDetail.trans_method = STATIC_VALUE.PAYMENT_METHOD.creditCard.value
                } else if (this._plantMapAdminService.vPlantMapDetail.trans_method === STATIC_VALUE.PAYMENT_METHOD.enets.key) {
                    this._plantMapAdminService.vPlantMapDetail.trans_method = STATIC_VALUE.PAYMENT_METHOD.enets.value
                } else if (this._plantMapAdminService.vPlantMapDetail.trans_method === STATIC_VALUE.PAYMENT_METHOD.dash.key) {
                    this._plantMapAdminService.vPlantMapDetail.trans_method = STATIC_VALUE.PAYMENT_METHOD.dash.value
                }
                this.openViewDetailPopup();
            },
            (reject) => {

            }
        );
    }

    openViewDetailPopup() {
        this._popupService.openPopup('view-plantmap', {
            title: 'Plant Map Reference No: ',
            buttons: {
                CANCEL: {
                    text: 'Cancel',
                    function: () => {
                        this._popupService.closePopup();
                        this._plantMapAdminService.resetPlantMapDetail();
                    }
                },
                OK: {
                    text: 'Reprint Map',
                    function: () => {
                        this._plantMapAdminService.reprintPlantmap().then(
                            (resolve) => {
                                this._popupService.closePopup();
                                this._popupService.openGeneralConfirmationPopup('Notice', 'Plant Map successfully printed', '', true, false);
                                this.filterPlant();
                            },
                            (reject) => {
                                this._popupService.openGeneralConfirmationPopup('Notice', 'Print Plant Map failed, please try again later', '', false, false);
                            }
                        );
                    }
                },
                NO: {
                    text: 'Print Map',
                    function: () => {
                        this._plantMapAdminService.printPlantmap();
                        // .then(
                        //     (resolve) => {
                        //         this._popupService.closePopup();
                        //         this._popupService.openGeneralConfirmationPopup('Notice', 'Plant Map successfully printed', '', true, false);
                        //         this.filterPlant();
                        //     },
                        //     (reject) => {
                        //         this._popupService.openGeneralConfirmationPopup('Notice', 'Print Plant Map failed, please try again later', '', false, false);
                        //     }
                        // );
                    }
                }
            },
        });
    }

    isLoading() {
        return this._plantMapAdminService.isLoading();
    }

    //Kowsalya
    accessstatus() {
        var access = JSON.parse(this._storageService.getLocalItem('access'));
        if (this.actionChecking('MANPL', access) && !(this.actionChecking('MANINU', access)) && !(this.actionChecking('MANEXU', access))) {
            return false;
        }
        else {
            return true;
        }
    }
    actionChecking(type, accesses) {
        for (var access of accesses) {
            if (access == type) {
                return true;
            }
        }
        return false;
    }

    //Kowsalya
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/plantmap-admin/components/all.component.ts